<!-- Begin page content -->
<main class="flex-shrink-0">
  <div class="container">
    <div class="row mt-3">
      <div class="col-lg-12">
        <!-- Champions section -->
        <section class="champs-content" id="champs">
          <div class="card mb-3" *ngFor="let item of winnerElement">
            <div class=" row g-0">
              <div class="col-lg-3">
                <!-- <img src="../../assets/img/32.png" alt="info"> -->
                <img src="{{item.image}}" alt="info" style="width: 100%;">
              </div>
              <div class="col-lg-9">
                <div class="card-body">
                  <div class="col-lg-12">
                    <h5 class="card-title">{{item.name}}</h5>
                  </div>
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-lg-6">
                        <span class="first">{{item.degree}}</span>
                      </div>
                      <div class="col-lg-6">
                        <span class="first">{{item.rank}}</span>
                      </div>
                    </div>
                    <br>
                    <div class="row">
                      <div class="col-lg-6">
                        <span translate class="sec">guide-item.dob</span> <br>
                        <span class="rt">{{item.bitrhday}}</span>
                      </div>
                      <div class="col-lg-6">
                        <span translate class="sec">guide-item.rank</span> <br>
                        <span class="rt">{{item.rank}}</span>
                      </div>
                    </div>
                    <br>
                    <div class="row">
                      <div class="col-lg-6">
                        <span translate class="sec">guide-item.place_of_residence</span> <br>
                        <span class="rt">{{item.address}}</span>
                      </div>
                      <div class="col-lg-6">
                        <span translate class="sec">guide-item.dot</span> <br>
                        <span class="rt">{{item.assigned_degree}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="lds-ripple" *ngIf="!winnerElement">
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="row mt-3 mb-3" *ngIf="winnerElement">
      <div class="col-lg-12">
        <section class="dost">
          <h2 translate>guide-item.achievements</h2>
          <span *ngFor="let item of description">
							{{item}} <br>
						</span>
        </section>
      </div>
    </div>
  </div>
</main>
